import { useEffect } from "react";
import { buildPersonJsonLd, buildWebsiteJsonLd } from "../../lib/seo";

const GLOBAL_ATTR = "data-global-seo";

export default function GlobalSeo() {
  useEffect(() => {
    const schemas = [buildWebsiteJsonLd(), buildPersonJsonLd()];
    let script = document.head.querySelector(`script#global-seo-jsonld[${GLOBAL_ATTR}]`);

    if (!script) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.id = "global-seo-jsonld";
      script.setAttribute(GLOBAL_ATTR, "");
      document.head.appendChild(script);
    }

    script.textContent = JSON.stringify(schemas);
  }, []);

  return null;
}
